import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import menu from 'assets/icons/menu.svg'
import Navigation from 'components/Navigation'

function Header() {
  const [showNavigation, setShowNavigation] = useState(false)
  const [isHeaderVisible, setIsHeaderVisible] = useState(true)

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPosition = window.scrollY
      setIsHeaderVisible(currentScrollPosition <= 200)
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const handleClick = () => {
    setShowNavigation(!showNavigation)
  }

  const handleCloseNavigation = () => {
    setShowNavigation(false)
  }

  return (
    <>
      <header
        className={`fixed z-30 w-full border-b-2 bg-white transition-all duration-500 ${
          isHeaderVisible ? 'top-0' : '-top-20'
        }`}
      >
        <nav className='m-4 flex items-center justify-between gap-4 text-lg text-dark md:m-6'>
          <a href='https://maciasecruzadvogados.com.br'>
            <h1 className='font-medium uppercase'>Macias & Cruz</h1>
          </a>

          <ul className='hidden items-center gap-8 md:flex'>
            <li>
              <Link to='/quem-somos' className='font-medium uppercase transition-all duration-500 hover:text-golden'>
                Quem somos
              </Link>
            </li>
            <li>
              <Link to='/advogados' className='font-medium uppercase transition-all duration-500 hover:text-golden'>
                Advogados
              </Link>
            </li>
            <li>
              <Link to='/servicos' className='font-medium uppercase transition-all duration-500 hover:text-golden'>
                Serviços
              </Link>
            </li>
            <li>
              <Link to='/contatos' className='font-medium uppercase transition-all duration-500 hover:text-golden'>
                Contatos
              </Link>
            </li>
          </ul>

          <div className='flex md:hidden' onClick={handleClick}>
            <img src={menu} alt='Menu' className='h-8 w-8 cursor-pointer' />
          </div>
        </nav>
      </header>

      <Navigation isOpen={showNavigation} onClose={handleCloseNavigation} />
    </>
  )
}

export default Header
